import React from 'react'
import { FormFields } from '@App/forms/v2/common/form-field'
import { FormFieldTypes } from '@App/enum/form-field-types'
import HFAPublisherNumberToolTip from '@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/IdentifiersSection/HFAPublisherNumberToolTip'
import IpiNumberToolTip from '@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/IdentifiersSection/IpiNumberToolTip'
import MemberTypeToolTip from '@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/MemberDetailsSection/MemberTypeToolTip'
import MemberSubTypeToolTip from '@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/MemberDetailsSection/MemberSubTypeToolTip'
import MemberNameToolTip from '@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/MemberDetailsSection/MemberNameToolTip'
import { addressFormKey, addressSchema, createAddressFormFields } from '@Entities/schemas/common/address-schema'
import { createPhoneNumberFormFields, phoneNumberFormKey } from '@Entities/schemas/common/phone-number-schema'

export type CreateRightsholderFormFieldsType = any

const memberTypeOptions = [
    { id: 'Songwriter', value: 'Songwriter', label: 'Self-Administered Songwriter' },
    { id: 'Publisher', value: 'Publisher', label: 'Publisher' },
    { id: 'CMO', value: 'CMO', label: 'CMO' },
    { id: 'Manager/Lawyer/Other', value: 'Manager/Lawyer/Other', label: 'Manager/Lawyer/Other' },
    { id: 'Administrator', value: 'Administrator', label: 'Administrator' },
]

const memberSubTypeOptions = [
    { id: 'Yes', value: 'Fully Administered', label: 'Yes' },
    { id: 'No', value: 'Self Administered', label: 'No' },
    { id: "I don't know", value: "I don't know", label: "I don't know" },
]

export const buildCreateRightsholderFormFieldsNoSchema = (): FormFields<CreateRightsholderFormFieldsType> => ({
    name: {
        name: 'name',
        label: 'Member name',
        type: FormFieldTypes.TEXT,
        inputHeader: (
            <h5>
                Member Name
                <MemberNameToolTip />
            </h5>
        ),
    },
    email: {
        name: 'email',
        label: 'Email',
        type: FormFieldTypes.TEXT,
    },
    memberType: {
        name: 'memberType',
        label: '',
        type: FormFieldTypes.DROPDOWN,
        placeholder: 'Select Member Type',
        className: 'register-dropdown',
        inputHeader: (
            <h5>
                Member Type
                <MemberTypeToolTip />
            </h5>
        ),
        options: memberTypeOptions,
    },
    memberSubType: {
        name: 'memberSubType',
        label: '',
        placeholder: "Select yes, no, or I don't know",
        type: FormFieldTypes.DROPDOWN,
        className: 'register-dropdown',
        inputHeader: (
            <p>
                Do you have a publisher, administrator, CMO, or digital distribution service collecting U.S. digital
                audio mechanical royalties on your behalf?
                <MemberSubTypeToolTip />
            </p>
        ),
        options: memberSubTypeOptions,
    },
    ipiNumber: {
        name: 'ipiNumber',
        label: 'IPI Number',
        type: FormFieldTypes.TEXT,
        tooltip: <IpiNumberToolTip />,
    },
    isni: {
        name: 'isni',
        label: 'ISNI',
        type: FormFieldTypes.TEXT,
    },
    hfaPublisherNumber: {
        name: 'hfaPublisherNumber',
        label: 'Publisher Account Number',
        type: FormFieldTypes.TEXT,
        tooltip: <HFAPublisherNumberToolTip />,
    },
    termsAndConditions: {
        name: 'termsAndConditions',
        label: 'Accept ',
        type: FormFieldTypes.CHECKBOX,
        className: 'terms-and-conditions',
    },
    [addressFormKey]: createAddressFormFields(addressFormKey, addressSchema) as any,
    [phoneNumberFormKey]: createPhoneNumberFormFields(phoneNumberFormKey) as any,
})
